<div>
    <app-mat-spinner-overlay *ngIf="showSpinner"></app-mat-spinner-overlay>

    <form #df="ngForm" novalidate>
        <div class="formborder">
            <div class="row m-0 col-md-12 p-0 ">
                <div class="col-md-3">
                    <span class="required-lable">From Date</span>
                    <div class="datepicker_feild">
                        <input [matDatepicker]="picker3" dateConvert placeholder="DD/MM/YYYY" name="FromDate"
                            [(ngModel)]="FromDate" #refFromDate="ngModel" [max]="ToDate" [ngClass]="{'is-invalid': df.submitted && refFromDate.invalid,
                'alert-warning':
                  refFromDate.invalid &&
                  (refFromDate.dirty ||
                    refFromDate.touched ||
                    refFromDate.untouched) }" class="form-control input-text-css" (dateChange)="clearTable()"
                            required />
                        <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                        <mat-datepicker #picker3></mat-datepicker>
                    </div>
                </div>

                <div class="col-md-3">
                    <span class="required-lable">To Date</span>
                    <div class="datepicker_feild">
                        <input [matDatepicker]="picker4" dateConvert placeholder="DD/MM/YYYY" name="ToDate"
                            (dateChange)="clearTable()" [(ngModel)]="ToDate" #refToDate="ngModel" [min]="FromDate"
                            [ngClass]="{'is-invalid': df.submitted && refToDate.invalid,
                'alert-warning':
                  refToDate.invalid &&
                  (refToDate.dirty ||
                    refToDate.touched ||
                    refToDate.untouched) }" class="form-control input-text-css" required />
                        <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                        <mat-datepicker #picker4></mat-datepicker>
                    </div>
                </div>

                <div class="col-md-3" *ngIf="dataSource?.data?.length">
                    <span class="required-lable"> Type</span>
                    <select name="Type" id="Type" (change)="changeType()" [(ngModel)]="Type"
                        class="form-control input-text-css" #refType="ngModel" required [ngClass]="{
                'is-invalid': f.submitted && refType.invalid,
                'alert-warning':
                  refType.invalid &&
                  (refType.dirty ||
                    refType.touched ||
                    refType.untouched)
              }">
                        <option value="SpredAmount">Spred Amount</option>
                        <option value="ClosingAmount">Closing Amount</option>
                    </select>
                </div>
                <div class="col-md-2 justify-content-end">
                    <button type="button" (click)="getMAS_EMIDifferenceTransfer()"
                        class="mt-3 btn font-size-12 button-btn" [disabled]="!df.form.valid">
                        Search
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <button class="btn font-size-12 button-btn mt-3" (click)="ExportTemplate()">
                        <i class="fa fa-file-import mr-1"></i> Export Template
                    </button>
                </div>
                <div class="col-md-3">
                    <button class="btn font-size-12 button-btn mt-3" (click)="ImportTable()">
                        <i class="fa fa-file-import mr-1"></i> Import Table
                    </button>
                </div>
            </div>
        </div>
    </form>

    <div class="table-responsive mt-3" *ngIf="dataSource">

        <mat-table [dataSource]="dataSource" matSort matTableExporter #exporter="matTableExporter">

            <!-- Serial Number -->
            <ng-container matColumnDef="sno">
                <mat-header-cell class="grid-header" style="max-width: 60px;" *matHeaderCellDef>#</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
                    {{ paginator.pageIndex * paginator.pageSize + (i + 1) }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="CustomerLoanAcNo">
                <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Customer Loan
                    A/c</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">{{ row.CustomerLoanAcNo }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="PartnerLoanNo">
                <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Partner Loan No</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">{{ row.PartnerLoanNo }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="CustomerName">
                <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Customer Name</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">{{ row.CustomerName }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="CustomerEmiAmount">


                <mat-header-cell mat-sort-header class="grid-header text-right" *matHeaderCellDef>Customer Emi


                    Amount</mat-header-cell>


                <mat-cell *matCellDef="let row" class="grid-cell text-center">


                    {{ row.CustomerEmiAmount }}


                </mat-cell>


            </ng-container>


            <ng-container matColumnDef="PartnerEmiAmount">


                <mat-header-cell mat-sort-header class="grid-header text-right" *matHeaderCellDef>Partner Emi


                    Amount</mat-header-cell>


                <mat-cell *matCellDef="let row" class="grid-cell text-center">


                    {{ row.PartnerEmiAmount }}


                </mat-cell>


            </ng-container>

            <ng-container matColumnDef="OpeningAmount">
                <mat-header-cell mat-sort-header class="grid-header text-right" *matHeaderCellDef>Opening
                    Amount</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell text-center">
                    {{ row.OpeningAmount }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="DRAmount">
                <mat-header-cell mat-sort-header class="grid-header text-right" *matHeaderCellDef>DR
                    Amount</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell text-center">
                    {{ row.DRAmount }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="CRAmount">
                <mat-header-cell mat-sort-header class="grid-header text-right" *matHeaderCellDef>CR
                    Amount</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell text-center">
                    {{ row.CRAmount }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ClosingAmount">
                <mat-header-cell mat-sort-header class="grid-header text-right" *matHeaderCellDef>Closing
                    Amount</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell text-center">
                    {{ row.ClosingAmount }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="SpredAmount">
                <mat-header-cell mat-sort-header class="grid-header text-right" *matHeaderCellDef>Spread
                    Amount</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell text-center">
                    {{ row.SpredAmount }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Transfer">
                <mat-header-cell class="grid-header text-center" *matHeaderCellDef>
                    <mat-checkbox [checked]="isAllSelected()" [indeterminate]="isIndeterminate()"
                        (change)="toggleAllSelection($event.checked)">
                    </mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell text-center">
                    <mat-checkbox [checked]="isRowSelected(row)" (change)="toggleRowSelection(row, $event.checked)">
                    </mat-checkbox>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="TransferAmount">
                <mat-header-cell class="grid-header text-right" *matHeaderCellDef>
                    Transfer Amount
                </mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell text-right">
                    <input type="number" class="form-control text-right" [value]="getTransferAmount(row)"
                        (input)="onTransferAmountChange(row, $event)">
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>


        <div class="row m-0 align-items-center mt-3">
            <div class="col-md-3">
                <button class="btn font-size-12 button-btn" (click)="exportTable(exporter)">
                    <i class="fa fa-file-export mr-1"></i> Export to Excel
                </button>
            </div>
            <div class="col-md-8">
                <mat-paginator #paginator [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons></mat-paginator>
            </div>
        </div>

    </div>
    <form #f="ngForm" novalidate class="d-flex justify-content-center">

        <div class="row mt-2 col-md-12 p-0 formborder" *ngIf="selectedRows.length > 0">
            <div class="col-md-3">
                <span class="required-lable">Voucher Date</span>
                <div class="datepicker_feild">
                    <input [matDatepicker]="picker4" dateConvert placeholder="DD/MM/YYYY" name="VoucherDate"
                        [(ngModel)]="VoucherDate" #refVoucherDate="ngModel" class="form-control input-text-css" required
                        [min]="FromDate" [max]="ToDate" [ngClass]="{
            'is-invalid': f.submitted && refVoucherDate.invalid,
            'alert-warning':
              refVoucherDate.invalid &&
              (refVoucherDate.dirty ||
                refVoucherDate.touched ||
                refVoucherDate.untouched)}" />
                    <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                    <mat-datepicker #picker4></mat-datepicker>
                </div>
            </div>

            <div class="col-md-3 mt-3">
                <button class="btn font-size-12 button-btn" [disabled]="f.invalid || selectedRows.length === 0"
                    (click)="Transfer(selectedRows)">
                    Transfer ({{ selectedRows.length }})
                </button>
            </div>
        </div>
    </form>


    <div class="modal fade in" id="EMISpreadTransferModel" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
        data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
                <div cdkDragHandle class="modal-header" style="padding: 10px">
                    <h6 class="modal-title">Import EMI Spread Transfer</h6>
                    <button type="button" (click)="onClose()" class="close" aria-label="Close">
                        <span aria-hidden="true">
                            <i class="far text-black fa-times-circle"></i>
                        </span>
                    </button>
                </div>

                <div class="modal-body">
                    <form #formRef="ngForm" novalidate class="row m-0 col-md-12 p-0 formborder">
                        <!-- File upload section -->
                        <div class="col-md-4">
                            <span>Upload Excel File</span>
                            <input type="file" id="importFileInput" #importFileInput accept=".xlsx, .xls"
                                (change)="onFileChange($event)" class="form-control input-text-css" required />
                            <small class="form-text text-muted">File must contain columns: PartnerLoanNo,
                                DiffAmount</small>
                        </div>
                        <div class="col-md-4">
                            <span class="required-lable">Voucher Date</span>
                            <div class="datepicker_feild">
                                <input [matDatepicker]="picker5" dateConvert placeholder="DD/MM/YYYY" name="ToDate"
                                    [(ngModel)]="bulkVoucherDate" #refbulkVoucherDate="ngModel" [min]="FromDate"
                                    [ngClass]="{'is-invalid': formRef.submitted && refbulkVoucherDate.invalid,
                                        'alert-warning':
                                          refbulkVoucherDate.invalid &&
                                          (refbulkVoucherDate.dirty ||
                                            refbulkVoucherDate.touched ||
                                            refbulkVoucherDate.untouched) }" class="form-control input-text-css"
                                    required />
                                <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                                <mat-datepicker #picker5></mat-datepicker>
                            </div>
                        </div>

                        <!-- Preview Table -->
                        <!-- <div class="col-md-12 mt-3" *ngIf="previewData.length">
                            <div class="table-responsive">
                                <table class="table table-bordered table-sm">
                                    <thead>
                                        <tr>
                                            <th>Partner Loan No</th>
                                            <th>Diff Amount</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let row of previewData"
                                            [style.backgroundColor]="!row.isValid ? '#ffebee' : ''">
                                            <td>{{ row.PartnerLoanNo }}</td>
                                            <td>{{ row.DiffAmount }}</td>
                                            <td>
                                                <span *ngIf="!row.isValid" class="text-danger">{{ row.errorMsg }}</span>
                                                <span *ngIf="row.isValid" class="text-success">Valid</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div> -->
                        <!-- Case 1: Before Server Validation (Review Mode) -->
                        <div class="col-md-12 mt-3" *ngIf="allImportEntries.length > 0 && !hasValidated">
                            <h6 class="mb-2">
                                Mismatched Records
                            </h6>
                            <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
                                <table class="table table-bordered table-sm validation-table">
                                    <thead class="thead-light" style="position: sticky; top: 0; z-index: 1;">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Partner Loan No</th>
                                            <th>Diff Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of allImportEntries; let i = index">
                                            <td class="text-center">{{ i + 1 }}</td>
                                            <td class="text-center" [class.error-cell]="!item.PartnerLoanNo">
                                                {{ item.PartnerLoanNo || '---' }}
                                            </td>
                                            <td class="text-right"
                                                [class.error-cell]="!item.DiffAmount || item.DiffAmount <= 0">
                                                {{ item.DiffAmount | number:'1.2-2' }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Case 2: After Server Validation (Results Mode) -->
                        <div class="col-md-12 mt-3" *ngIf="hasValidated">
                            <!-- Matched Records Table -->
                            <div *ngIf="validImportEntries.length > 0" class="mb-3">
                                <h6 class="text-success mb-2">✓ Matched Records </h6>
                                <div class="table-responsive" style="max-height: 250px; overflow-y: auto;">
                                    <table class="table table-bordered table-sm">
                                        <thead class="bg-success text-white">
                                            <tr>
                                                <th class="text-center">S.No</th>
                                                <th>Partner Loan No</th>
                                                <th class="text-right">Diff Amount</th>
                                                <th class="text-center">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of validImportEntries; let i = index">
                                                <td class="text-center">{{ i + 1 }}</td>
                                                <td>{{ item.PartnerLoanNo }}</td>
                                                <td class="text-right">{{ item.DiffAmount | number:'1.2-2' }}</td>
                                                <td class="text-success text-center">Matched</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <!-- Unmatched Records Table -->
                            <div *ngIf="invalidImportEntries.length > 0">
                                <h6 class="mb-2">✗ Un-Matched Records
                                </h6>
                                <div class="table-responsive" style="max-height: 250px; overflow-y: auto;">
                                    <table class="table table-bordered table-sm">
                                        <thead class="bg-danger text-white">
                                            <tr>
                                                <th class="text-center">S.No</th>
                                                <th>Partner Loan No</th>
                                                <th class="text-right">Diff Amount</th>
                                                <th>Reason</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of invalidImportEntries; let i = index"
                                                style="background-color: #fff5f5;">
                                                <td class="text-center">{{ i + 1 }}</td>
                                                <td class="error-cell">{{ item.PartnerLoanNo || '---' }}</td>
                                                <td class="text-right"
                                                    [class.error-cell]="!item.DiffAmount || item.DiffAmount <= 0">
                                                    {{ item.DiffAmount | number:'1.2-2' }}</td>
                                                <td class="text-danger">
                                                    <small>{{ item.NotMach }}</small>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12" *ngIf="fileUploaded && allImportEntries.length === 0">
                            <div class="alert alert-info mt-2">No valid data found or file parsing failed.</div>
                        </div>

                        <!-- Buttons -->
                        <div class="row m-0 mt-3 col-md-12 p-0 justify-content-end">
                            <button type="button" (click)="onSave()"
                                [disabled]="formRef.invalid || !hasValidated || invalidImportEntries.length > 0"
                                *ngIf="allImportEntries.length > 0 && hasValidated" class="btn font-size-12 button-btn">
                                Save Import
                            </button>
                            <button type="button" (click)="onClose()" class="btn font-size-12 button-btn ml-2">
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>